import { Layout } from "../Layout";
import { LoggingEvent } from "../LoggingEvent";

/**
 * Макет для вывода логов в формате: {LOGGER_NAME}: [message]
 */
export class LoggerNameWithMessageLayout implements Layout {
  public format(event: LoggingEvent): string {
    return `${event.logger}: [${event.message}]`;
  }
}
